import * as R from "runtypes";

import { typedObjectKeys } from "../../utils/typedObjects.js";

/**
 * Runtypes are necessary to define each entity's configuration; this is a utility function to convert an enum to a runtype!
 */
export const convertEnumToRuntype = <T extends string>(
  enumObj: Record<T, T>,
): R.Union<[R.Literal<T>, ...R.Literal<T>[]]> => {
  const [first, ...rest] = typedObjectKeys(enumObj);
  return R.Union<[R.Literal<T>, ...R.Literal<T>[]]>(
    R.Literal(first!),
    // eslint-disable-next-line tree-shaking/no-side-effects-in-initialization -- https://github.com/lukastaegert/eslint-plugin-tree-shaking/issues/71
    ...rest.map((k) => R.Literal(k)),
  );
};
